import {registerComponent} from '@helpers/vue'

import router from './router'
import DlgCertModuleRoot from './DlgCertModuleRoot'

registerComponent(DlgCertModuleRoot, 'dlg-cert', {router})
